var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('el-cascader',{attrs:{"props":_vm.props,"placeholder":_vm.placeholder,"clearable":_vm.clearable},on:{"change":function($event){return _vm.$emit('change')},"input":_vm.handleInput},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }